<template>
  <section class="app-transporte">
    <v-card outlined class="app-card">
      <v-card-title class="app-card-title">
        <v-icon left>search</v-icon> Placas
      </v-card-title>
      <v-card-text class="app-card-content">
        <v-text-field
          v-model="search"
          label="Buscar placa"
          placeholder="Digite a placa"
          prepend-inner-icon="search"
          filled
          rounded
          dense
          clearable
          hide-details
          class="mb-4"
        ></v-text-field>

        <div v-if="isLoadingPlacas" class="text-center py-8">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>

        <v-alert v-else-if="!placasFiltradas.length" text outlined type="info">
          Nenhuma placa encontrada para a transportadora
        </v-alert>

        <template v-else>
          <v-row dense>
            <v-col
              v-for="placa in placasPaginadas"
              :key="placa"
              cols="6"
              sm="4"
              md="3"
              lg="2"
            >
              <v-btn
                block
                outlined
                color="primary"
                class="placa-btn"
                @click="selecionarPlaca(placa)"
              >
                {{ placa }}
              </v-btn>
            </v-col>
          </v-row>

          <v-pagination
            v-if="totalPaginas > 1"
            v-model="page"
            :length="totalPaginas"
            :total-visible="7"
            class="mt-6"
          ></v-pagination>

          <p class="text-center caption mt-2 mb-0">
            {{ placasFiltradas.length }} placa(s) encontrada(s)
          </p>
        </template>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogCaptcha" max-width="400" persistent>
      <v-card>
        <v-card-title class="app-card-title">
          Placa {{ placaSelecionada }}
        </v-card-title>
        <v-card-text>
          <p class="mb-4">
            Confirme que você não é um robô para consultar as pendências da
            placa.
          </p>
          <vue-recaptcha
            ref="recaptcha"
            :sitekey="siteKey"
            :loadRecaptchaScript="true"
            @verify="verifyRecaptcha"
            @expired="expiredRecaptcha"
            class="recaptcha"
          ></vue-recaptcha>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="fecharDialog" :disabled="isLoading">
            Cancelar
          </v-btn>
          <v-btn
            depressed
            color="primary"
            :disabled="!form.recaptcha"
            :loading="isLoading"
            @click="consultar"
          >
            Consultar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <br />
    <div id="resultadoPendencias"></div>
    <ResultadoPendencias v-if="veiculo" :veiculo="veiculo" />
  </section>
</template>

<script>
import Vue from "vue";
import VueRecaptcha from "vue-recaptcha";
import { VUE_APP_RECAPTCHA_KEY } from "@/commons/config";
import PendenciaService from "@/services/pendencia.service";
import TransportadoraAuthService from "@/services/transportadora.auth.service";
import ResultadoPendencias from "@/views/transportes/consulta-pendencias/ResultadoPendencias";

export default Vue.extend({
  components: {
    VueRecaptcha,
    ResultadoPendencias
  },
  metaInfo: {
    title: "Consulta De Pêndencias - Central de Serviços"
  },
  data() {
    return {
      siteKey: VUE_APP_RECAPTCHA_KEY,
      isLoadingPlacas: false,
      isLoading: false,
      search: "",
      placas: [],
      page: 1,
      itemsPerPage: 48,
      dialogCaptcha: false,
      placaSelecionada: null,
      form: {
        recaptcha: null
      },
      veiculo: null
    };
  },
  computed: {
    transportadoraCnpj() {
      return TransportadoraAuthService.currentTransportadoraValue.cnpj;
    },
    transportadoraToken() {
      return TransportadoraAuthService.currentTransportadoraValue.token;
    },
    placasFiltradas() {
      const termo = (this.search || "")
        .trim()
        .toUpperCase()
        .replace(/-/g, "");

      if (!termo) {
        return this.placas;
      }

      return this.placas.filter(placa =>
        String(placa)
          .toUpperCase()
          .replace(/-/g, "")
          .includes(termo)
      );
    },
    totalPaginas() {
      return Math.ceil(this.placasFiltradas.length / this.itemsPerPage);
    },
    placasPaginadas() {
      const inicio = (this.page - 1) * this.itemsPerPage;
      return this.placasFiltradas.slice(inicio, inicio + this.itemsPerPage);
    }
  },
  watch: {
    // ao filtrar, a pagina atual pode deixar de existir
    search() {
      this.page = 1;
    }
  },
  methods: {
    carregarPlacas() {
      this.isLoadingPlacas = true;
      PendenciaService.listarPlacas(this.transportadoraCnpj).subscribe(
        response => {
          this.placas = response || [];
          this.isLoadingPlacas = false;
        },
        () => {
          this.placas = [];
          this.isLoadingPlacas = false;
        }
      );
    },
    selecionarPlaca(placa) {
      this.placaSelecionada = placa;
      this.form.recaptcha = null;
      this.dialogCaptcha = true;
    },
    verifyRecaptcha(value) {
      this.form.recaptcha = value;
    },
    expiredRecaptcha() {
      if (this.$refs.recaptcha) {
        this.$refs.recaptcha.reset();
      }
      this.form.recaptcha = null;
    },
    fecharDialog() {
      this.dialogCaptcha = false;
      this.expiredRecaptcha();
    },
    consultar() {
      if (!this.form.recaptcha) {
        return;
      }
      this.isLoading = true;

      const cnpj = this.transportadoraCnpj;
      const token = this.transportadoraToken;
      const placa = this.placaSelecionada;

      PendenciaService.buscarPendencias(
        cnpj,
        token,
        this.form.recaptcha,
        placa
      ).subscribe(
        veiculo => {
          this.veiculo = veiculo;
          this.isLoading = false;
          this.dialogCaptcha = false;
          this.expiredRecaptcha();
          this.$nextTick(() => this.$vuetify.goTo("#resultadoPendencias"));
        },
        () => {
          this.isLoading = false;
          this.veiculo = null;
          this.expiredRecaptcha();
        }
      );
    }
  },
  mounted() {
    this.carregarPlacas();
  }
});
</script>

<style lang="scss" scoped>
.placa-btn {
  font-family: "Roboto Mono", monospace;
  font-weight: 700;
  letter-spacing: 1px;
}
</style>
